/*
 * App Actions
 *
 */
import {
  UPDATE_FILTER,
  UPDATE_SORTING,
  UPDATE_IOC_LIST,
  UPDATE_IOC_LIST_FROM_CACHE,
  PAGINATION_IOC_LIST,
  PAGINATION_IOC_LIST_FROM_CACHE,
  UPDATE_TAG,
} from '../constants';

export function updateFilter(filters) {
  return {
    type: UPDATE_FILTER,
    filters,
  };
}

export function updateTag(tag) {
  return {
    type: UPDATE_TAG,
    tag,
  };
}

export function updateSorting(sorting) {
  return {
    type: UPDATE_SORTING,
    sorting,
  };
}

export function updateIocList({
  pagination,
  filters,
  sorting,
  distinct,
  filterProfile,
  tag,
  feed_state,
}) {
  return {
    type: UPDATE_IOC_LIST,
    pagination,
    filters,
    sorting,
    distinct,
    filterProfile,
    tag,
    feed_state,
  };
}

export function updateIocListFromCache({
  pagination,
  filters,
  sorting,
  distinct,
  filterProfile,
  tag,
  feed_state,
}) {
  return {
    type: UPDATE_IOC_LIST_FROM_CACHE,
    pagination,
    filters,
    sorting,
    distinct,
    filterProfile,
    tag,
    feed_state,
  };
}

export function paginationIocList({
  pagination,
  filters,
  sorting,
  distinct,
  filterProfile,
  tag,
  feed_state,
}) {
  return {
    type: PAGINATION_IOC_LIST,
    pagination,
    filters,
    sorting,
    distinct,
    filterProfile,
    tag,
    feed_state,
  };
}

export function paginationIocListFromCache({
  pagination,
  filters,
  sorting,
  distinct,
  filterProfile,
  tag,
  feed_state,
}) {
  return {
    type: PAGINATION_IOC_LIST_FROM_CACHE,
    pagination,
    filters,
    sorting,
    distinct,
    filterProfile,
    tag,
    feed_state,
  };
}
